import { PFRatioData, LactateData, Vitals, BloodGases } from '@features/components/ClinicalData/sections';
import { getColorsByOrganType, isAllowedStatus } from '@/utils/helpers';
import { ClinicalData, OrganType } from '@/api/apis/case/clinical-data.types';
import { CaseStatus, DonorType } from '@/api/apis/case';

type OrganSpecificDataProps = {
  organType: OrganType;
  donorType: DonorType;
  clinicalData: ClinicalData;
  status: CaseStatus;
  isTrialCase: boolean;
};

export const OrganSpecificSection = ({
  organType,
  donorType,
  clinicalData,
  status,
  isTrialCase,
}: OrganSpecificDataProps) => {
  const colors = getColorsByOrganType(organType);
  const showVitals = isAllowedStatus({ statusTo: CaseStatus.AtDonorHospital, currentStatus: status });
  if (organType === OrganType.Lungs) {
    if (isTrialCase) return <BloodGases clinicalData={clinicalData} />;
    return <PFRatioData clinicalData={clinicalData} color={colors.bg40} />;
  }
  if (donorType === DonorType.DCD && showVitals) {
    return <Vitals organType={organType} clinicalData={clinicalData} />;
  }
  return <LactateData organType={organType} clinicalData={clinicalData} />;
};
